import { render, staticRenderFns } from "./AssinanteDesempenho.vue?vue&type=template&id=5d3aebab&scoped=true&"
import script from "./AssinanteDesempenho.vue?vue&type=script&lang=js&"
export * from "./AssinanteDesempenho.vue?vue&type=script&lang=js&"
import style0 from "./AssinanteDesempenho.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AssinanteDesempenho.vue?vue&type=style&index=1&id=5d3aebab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3aebab",
  null
  
)

export default component.exports